import React, { useState, useEffect, useContext } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { globalConfig } from "../../config/config";
import { useAuth0 } from "@auth0/auth0-react";
import { toast } from 'react-toastify';

const initialService = {
      scanJobId: 0,
      scanJobName: "",
      scanJobDescription: "",
      startTime: new Date().toISOString(),
      endTime: new Date().toISOString(),
      contentInputSourceId: 0,
      securityContextId: 0,
      createUser: 0,
      createDate: new Date().toISOString(),
      lastUpdateUser: 0,
      lastUpdateDate: new Date().toISOString(),
      timeoutPeriod: 0,
      taskTime: new Date().toISOString(),
      taskDate: new Date().toISOString(),
      runIntervalValue: 0,
      runDays: "",
      runIntervalType: "",
};
const initialState = {
    services: [],
	service: initialService,
    currentServiceId: 0,
  };

const ServiceScheduler = () => {
  const [auditFrequency, setAuditFrequency] = useState([]);
  const [status, setStatus] = useState([]);
  const [connectors, setConnectors] = useState([]);
  const [state, setState] = useState(initialState);
  const	[userMetadata, setUserMetadata] = useState({});

// 	const userMetadata = useContext(AuthContext);

//   		const getUserMetadata = async () => {
//   			const claims = await getIdTokenClaims();
//   			const namespace = 'https://app.gazelleplatform.com';
//   			const userMetadata = claims[`${namespace}/user_metadata`];
//   		}
  
  const { user, getIdTokenClaims } = useAuth0();
  useEffect(() => {
   		if (user) {

    const checkClaims = async () => {
      const claims = await getIdTokenClaims();
      const namespace = 'https://app.gazelleplatform.com';
      const umd = claims[`${namespace}/user_metadata`];
      setUserMetadata(umd);
      console.log(userMetadata.userId);
    };
    
    checkClaims();
  		} 		
  	}, [user]);

//   alert(JSON.stringify(user));


  


  	
  useEffect(() => {
    handleOnLoad();
  }, []);

  useEffect(() => {
    console.log(state);
  }, [state]);

  const handleOnLoad = () => {
    axios
      .get(
        `${globalConfig.apiDatahubUrl}/scan-jobs`,
        globalConfig.hardcoded_header
      )
      .then((res) => {
        const services = res.data;
//         console.log(services);
        setState({ ...state, services: services });
//         console.log(res.data[0]);
      });

    axios
      .get(
        `${globalConfig.apiDatahubUrl}/content-input-sources`,
        globalConfig.hardcoded_header
      )
      .then((res) => {
        const connectors = res.data;
//         console.log(connectors);
        setConnectors(connectors);
      });

    axios
      .get(
        `${globalConfig.systemCodesUrl}/AUDIT_FREQUENCY`,
        globalConfig.hardcoded_header
      )
      .then((res) => {
        const auditFrequency = res.data;
//         console.log(auditFrequency);
        setAuditFrequency(auditFrequency);
      });

    axios
      .get(
        `${globalConfig.systemCodesUrl}/TRANSFORMATION_STATUS`,
        globalConfig.hardcoded_header
      )
      .then((res) => {
        const transformation_status = res.data;
//         console.log(transformation_status);
        setStatus(transformation_status);
      });
    // if (state.currentServiceId > 0) {
    //   axios
    //     .get(
    //       `${globalConfig.apiDatahubUrl}/scan-jobs/${state.currentServiceId}`,
    //       globalConfig.hardcoded_header
    //     )
    //     .then((res) => {
    //       const service = res.data;
    //       console.log(service);
    //       setState({ ...state, service: service });
    //     });
    // }
  };

  function handleOnChange(event) {
    setState({ ...state, currentServiceId: event.target.value });

    if (parseInt(event.target.value) !== 0) {
      axios
        .get(
          `${globalConfig.apiDatahubUrl}/scan-jobs/${event.target.value}`,
          globalConfig.hardcoded_header
        )
        .then((res) => {
          const service = res.data;
//           console.log(service);
          setState({
            ...state,
            service: service,
            currentServiceId: service.scanJobId,
          });

        });
    }
  }
  
  const handleOnDelete = (e, id) => {
  	e.preventDefault();
  	console.log('event.target.value => ' + id);
  	let  confirmation = confirm('are you sure you want to delete the service with id: ' + parseInt(id));
    if (confirmation && parseInt(id) > 0) {

		let url = `${globalConfig.apiDatahubUrl}/scan-jobs/${id}`;
      axios
        .delete(
        	url,
          globalConfig.hardcoded_header
        )
        .then((res) => {
          const response = res.data;
          console.log('response -> ' + response);
          if (res.status === 200) {
          	// success
          	toast.success('Service has been deleted');
          	handleOnClear(e);
          } else if (res.status === 404) {
	          // not found
    	      toast.error('Service deletion failed');
          } else {
    	      // handle other codes
    	      toast.error('Service deletion failed');
          }
        });
    }

  }
  
  const handleConnectorChange = (e) => {
  	setState({...state, service: {...state.service, contentInputSourceId: e.target.value}});
  }
  
  const handleOnSave = (e) => {
  	e.preventDefault();

		if (state.service.scanJobId > 0)
		{
			state.service.lastUpdateUser = userMetadata.userId;
			state.service.lastUpdateDate = new Date();
			let url = `${globalConfig.apiDatahubUrl}/scan-jobs/${state.service.scanJobId}`;
	      axios
    	    .put(
        		url,
        		state.service,
          		globalConfig.hardcoded_header
        	)
        	.then((res) => {
          		const response = res.data;
	          console.log('response -> ' + response);
    	      if (res.status === 200) {
        	  	// success
          		handleOnLoad();
          		toast.success('Service schedule was updated');
//           	setState({ ...state, service: {} });
    	      } else if (res.status === 404) {
	    	      // not found
          	} else {
    	    	  // handle other codes
          	}
			}
        	)
        	.catch((err) => {
    			console.error('Create failed:', err.response?.status, err.response?.data);
    			toast.error('Failed to create service');
  			});		}
		else 
		{
			toast.error('Invalid service information - update failed');
    	}
  }
  const handleOnClear = (e) => {
  	e.preventDefault();
  	setState({...state, currentServiceId: 0, service: initialService});
  }
  const handleOnScheduleService = (e) => {
  	e.preventDefault();
  	handleOnSave(e);
  	toast.success('Service has been saved and scheduled automatically');
  }

  return (
    <div>
      <form>
        <div className="container-fluid">
	<div className="d-flex flex-row justify-content-between mb-3 mt-3">
          <h4>Data Service Scheduler</h4>
			  <div>
            <Link to="/neo/create-service" className="btn-success btn">
              Create Service
            </Link>
            &nbsp;
            <Link to="/" className="btn-primary btn">
              Home
            </Link>
            &nbsp;
            <Link to="/neo" className="btn-warning btn">
              Back
            </Link>
            </div>
      </div>

          <hr />
          <div className="form-group row">
            <label className="ContentTitle col-sm-2">Select Service</label>
            <select
              className="form-control input-big col-sm-8"
              id="scanJobId"
              value={state.currentServiceId}
              onChange={handleOnChange}
            >
              <option >Select A Service</option>
              {state.services.map((service) => (
                <option key={service.scanJobId} value={service.scanJobId}>
                  {service.scanJobName}
                </option>
              ))}
            </select>
          </div>
          <hr />
          <div className="form-group row">
            <label className="ContentTitle col-sm-2" value="Name: ">
              Name
            </label>
            <input
              id="name"
              className="form-control input-big col-sm-8"
              value={state.service.scanJobName}
            ></input>
          </div>
          <div className="form-group row">
            <label className="ContentTitle col-sm-2" value="Service ID : ">
              Service Id
            </label>
            <input
              id="selectedServiceId"
              readonly="true"
              className="form-control col-sm-8"
              value={state.service.scanJobId}
            />
          </div>
          <div className="form-group row">
            <label className="ContentTitle col-sm-2" value="Description: ">
              Description
            </label>
            <textarea
              id="description"
              value={state.service.scanJobDescription}
              className="form-control input-big col-sm-8"
              onChange={(e) => setState({...state, service: {...state.service, scanJobDescription: e.target.value}})}
            ></textarea>
          </div>
          <div className="form-group row">
            <label className="ContentTitle col-sm-2">Begin Date</label>
            <input
              className="form-control input-big col-sm-8"
              type="datetime-local"
              id="startTime"
              value={state.service.startTime?.slice(0, 16)}
              onChange={(e) => setState({...state, service: {...state.service, startTime: e.target.value}})}
            />
          </div>
          <div className="form-group row">
            <label className="ContentTitle col-sm-2">End Date</label>
            <input
              className="form-control input-big col-sm-8"
              type="datetime-local"
              id="endTime"
              value={state.service.endTime?.slice(0, 16)}
              onChange={(e) => setState({...state, service: {...state.service, endTime: e.target.value}})}
            ></input>
          </div>
          <div className="form-group row">
            <label className="ContentTitle col-sm-2">Timeout</label>
            <input
              className="form-control input-medium col-sm-8"
              id="timeoutPeriod"
              value={state.service.timeoutPeriod}
              onChange={(e) => setState({...state, service: {...state.service, timeoutPeriod: parseInt(e.target.value)}})}
            />
          </div>
          <div className="form-group row">
            <label className="ContentTitle col-sm-2">Run Every</label>

            <input
              className="form-control input-small col-sm-1"
              id="runIntervalValue"
              value={state.service.runIntervalValue}
              onChange={(e) => setState({...state, service: {...state.service, runIntervalValue: parseInt(e.target.value)}})}
            ></input>
            <select
              className="form-control input-small col-sm-7"
              id="runIntervalType"
              name="runIntervalType"
              value={state.service.runIntervalType}
              onChange={(e) => setState({...state, service: {...state.service, runIntervalType: e.target.value}})}
            >
              <option >Select Frequency</option>

              {auditFrequency.map(
                ({ systemCodeId, systemCodeValueValue, systemCodeValueId }) => (
                  <option key={systemCodeValueId} value={systemCodeId}>
                    {systemCodeValueValue}{" "}
                  </option>
                )
              )}
            </select>
          </div>
          <div className="form-group row">
            <label value="Connector" className="ContentTitle col-sm-2">
              Connector
            </label>
            <select
              id="dataSources"
              className="form-control col-sm-8"
              value={state.service.contentInputSourceId}
              onChange={(e) => setState({...state, service: {...state.service, contentInputSourceId: parseInt(e.target.value)}})}
            >
              <option>Select A Connector</option>
              {connectors.map(
                ({ contentInputSourceId, contentInputSourceName }, index) => (
                  <option key={index} value={contentInputSourceId}>
                    {contentInputSourceName}
                  </option>
                )
              )}
            </select>
          </div>

          <div className="form-group row">
            <label value="Status" className="ContentTitle col-sm-2">
              Status
            </label>
            <select  id="statusCode" className="form-control input-big col-sm-8"
            	value={state.status}
            	onChange={(e) => setState({status: parseInt(e.target.value)})}
            >
            <option >Select Status</option>
              {status.map(
                ({ systemCodeId, systemCodeValueValue, systemCodeValueId }) => (
                  <option key={systemCodeValueId} value={systemCodeId}>
                    {systemCodeValueValue}{" "}
                  </option>
                )
              )}
            </select>
          </div>

          <div className="form-group row">
            <label className="ContentTitle col-sm-2" value="Task Run Date">
              Task Run Date
            </label>
            <input
              className="form-control input-big col-sm-8"
              type="datetime-local"
              id="taskDate"
              name="taskDate"
              value={state.service.taskDate?.slice(0, 16)}
              onChange={(e) => setState({...state, service: {...state.service, taskDate: e.target.value}})}
            ></input>
          </div>
          <div className="form-group row">
            <label className="ContentTitle col-sm-2" value="Task Run Time">
              Task Run Time
            </label>
            <input
              className="form-control input-big col-sm-8"
              type="datetime-local"
              id="taskTime"
              name="taskTime"
              value={state.service.taskTime?.slice(0, 16)}
              onChange={(e) => setState({...state, service: {...state.service, taskTime: e.target.value}})}
            ></input>
          </div>

          <hr />
          <center>
            <button
              className="btn btn-info"
              value="Schedule This Service"
                 onClick={(e) => {handleOnScheduleService(e)}}
            >
              Schedule This Service
            </button>
            &nbsp;
            <button
              className="btn btn-primary"
              value="Start"
              //   onClick={handleOnStartService}
            >
              Start
            </button>
            &nbsp;
            <button
              className="btn btn-warning"
              value="Stop"
              //   onClick={handleOnStopService}
            >
              Stop
            </button>
            &nbsp;
            <button
              value="Delete"
              className="btn btn-danger"
                 onClick={(e) => {handleOnDelete(e, state.service.scanJobId)}}
            >
              Delete
            </button>
            &nbsp;
            <button
              value="Save"
              className="btn btn-success"
              onClick={(e) => {handleOnSave(e)}}
            >
              Save
            </button>
            &nbsp;
            <button
              value="Clear"
              className="btn btn-secondary"
              	onClick={(e) => {handleOnClear(e)}}
            >
              Clear
            </button>
          </center>
        </div>
      </form>
    </div>
  );
};

export default ServiceScheduler;


//               onChange={(e) => {handleConnectorChange(e)}}

// export default class ServiceScheduler extends Component {

// 	constructor(props)
// 	{
// 		console.log(props);
// 		super(props);
// 		this.state = {
//     			services: [],
// 			service : {
// 					"scanJobId": 0,
// 					  "scanJobName": "",
// 					  "scanJobDescription": "",
// 					  "startTime": new Date(),
// 					  "endTime": new Date(),
// 					  "contentInputSourceId": 0,
// 					  "securityContextId": 0,
// 					  "createUser": 0,
// 					  "createDate": new Date(),
// 					  "lastUpdateUser": 0,
// 					  "lastUpdateDate": new Date(),
// 					  "timeoutPeriod": 0,
// 					  "taskTime": new Date(),
// 					  "taskDate": new Date(),
// 					  "runIntervalValue": 0,
// 					  "runDays": "",
// 					  "runIntervalType": ""
// 			},
// 			currentServiceId : 0
//   		};
// 		this.handleOnLoad = this.handleOnLoad.bind(this);
//         this.handleOnChange = this.handleOnChange.bind(this);
// 	}
// 	componentDidMount()
// 	{
// 		this.handleOnLoad();
// 	}
// 	const handleOnLoad = () => {
//       		axios.get(`http://os-dev.origosoftware.com:3000/scan-jobs/`).then(res => {
//       		const services = res.data;
//       		console.log(services);
//       		this.setState({ "services" : services });
//       		console.log(res.data[0]);
// 		});

// 		if (this.state.currentServiceId > 0)
// 		{
// 	      		axios.get(`http://os-dev.origosoftware.com:3000/scan-jobs/${this.state.currentServiceId}`).then(res => {
//       			const service = res.data;
//       			console.log(service);
//       			this.setState({ service : service });
// 			});
// 		}
// 	}
// 	handleOnClear = () => {
// 	}
// 	handleOnSave = () => {
// 	}
// 	handleOnDelete = () => {
// 	}
// 	handleOnStartService = () => {
// 	}
// 	handleOnStopService = () => {
// 	}
// 	handleOnScheduleService = () => {
// 	}
// 	function handleOnChange(event) {
//         this.setState({ currentServiceId: event.target.key });
//         console.log('set new service id = ' + this.state.currentServiceId);
// 		if (this.state.currentServiceId > 0)
// 		{
// 	      		axios.get(`http://os-dev.origosoftware.com:3000/scan-jobs/${this.state.currentServiceId}`).then(res => {
//       			const service = res.data;
//       			console.log(service);
//       			this.setState({ service : service });
// 			});
// 		}
// 	}

// 	render(){

//         return (

// 	<form>
// 		<div className="container-fluid">
// 		<h4>Data Service Scheduler</h4>
// 		<hr />
// 		<div className="form-group row">
// 			<label className="ContentTitle col-sm-2">Select Service</label>
// 			<select className="form-control input-big col-sm-8" id="scanJobId" onChange={this.handleOnChange}>
// 			{this.state.services.map((service) => <option key={service.scanJobId} value={service.scanJobId}>{service.scanJobName}</option>)}
// 			</select>
// 		</div>
// 			<hr />
// 		<div className="form-group row">
// 			<label className="ContentTitle col-sm-2" value="Name: ">Name
// 			</label>
// 					<input id="name" className="form-control input-big col-sm-8" value={this.state.service.scanJobName }></input>
// 		</div>
// 		<div className="form-group row">
// 			<label className="ContentTitle col-sm-2" value="Service ID : ">Service Id</label>
// 			<input id="selectedServiceId" readonly="true" className="form-control col-sm-8" value={this.state.service.scanJobId } />
// 		</div>
// 		<div className="form-group row">
// 			<label className="ContentTitle col-sm-2" value="Description: ">
// 				Description
// 			</label>
// 			<textArea id="description"   value={this.state.service.scanJobDescription } className="form-control input-big col-sm-8" >
// 			</textArea>
// 		</div>
// 		<div className="form-group row">
// 			<label className="ContentTitle col-sm-2" >Begin Date</label>
// 			<input className="form-control input-big col-sm-8"  type="datetime-local" id="startTime" value={this.state.service.startTime }>
// 			</input>
// 		</div>
// 		<div className="form-group row">
// 						<label className="ContentTitle col-sm-2" >End Date</label>
// 						<input  className="form-control input-big col-sm-8"  type="datetime-local" id="endTime" value={this.state.service.endTime }>
// 						</input>
// 		</div>
// 		<div className="form-group row">

// 						<label className="ContentTitle col-sm-2" >Timeout</label>
// 						<input className="form-control input-medium col-sm-8" id="timeoutPeriod"  value={this.state.service.timeoutPeriod } />
// 		</div>
// 		<div className="form-group row">
//                 <label className="ContentTitle col-sm-2">Run Every</label>

//                 <input className="form-control input-small col-sm-1" id="runIntervalValue"  value={this.state.service.runIntervalValue}></input>
//                 <select className="form-control input-small col-sm-7" id="runIntervalType" name="runIntervalType" value={this.state.service.runIntervalType}>
// 	            </select>

// 		</div>
// 		<div className="form-group row">

// 				<label value="Connector" className="ContentTitle col-sm-2" >Connector</label>
// 				<select id="dataSources" className="form-control col-sm-8" value={this.state.service.contentInputSourceId }>
// 				</select>
// 		</div>
// 		<div className="form-group row">
// 				<label value="Status" className="ContentTitle col-sm-2">Status</label>
// 				<select id="statusCode" className="form-control input-big col-sm-8">
// 				</select>
// 		</div>
// 		<div className="form-group row">
//              <label className="ContentTitle col-sm-2"  value="Task Run Date">Task Run Date</label>
//              <input className="form-control input-big col-sm-8" type='date'  id="taskDate" name="taskDate" value={this.state.service.taskDate } >
//              </input>
// 		</div>
// 		<div className="form-group row">
//              <label className="ContentTitle col-sm-2"  value="Task Run Time">Task Run Time</label>
//              <input className="form-control input-big col-sm-8" type='time' id="taskTime" name="taskTime" value={this.state.service.taskTime} >
//              </input>

// 		</div>

// 		<hr />
// 		<center>
// 				<button className="btn btn-info" value="Schedule This Service" onClick={this.handleOnScheduleService}>Schedule This Service</button>&nbsp;
// 				<button className="btn btn-primary" value="Start" onClick={this.handleOnStartService}>Start</button>&nbsp;
// 				<button className="btn btn-warning" value="Stop" onClick={this.handleOnStopService}>Stop</button>&nbsp;
//    				<button value="Delete"  className="btn btn-danger" onClick={this.handleOnDelete}>Delete</button>&nbsp;
//    				<button value="Save"  className="btn btn-success" onClick={this.handleOnSave}>Save</button>&nbsp;
//    				<button value="Clear"  className="btn btn-secondary"  onClick={this.handleOnClear }>Clear</button>
// 		</center>
// 		</div>
//     	</form>
// );
// }
// }
